import { useState, useEffect } from 'react';

const Especies =
({
    checking,
    setChecking,
    codigosEspecies,
    setCodigosEspecies,
    checkboxesEspecies,
    setCheckboxesEspecies,
    especies,
    sorting,
    loading,
    setPagination,
    status422
}) =>
{
    const [count, setCount] = useState(0);

    const appDebug = process.env.REACT_APP_DEBUG;

    const handleChildCheckbox = (e) =>
    {
        setChecking(true);

        const checked = e.target.checked;
        const especie = e.target.value;

        if (checked === true)
        {
            const especies = [];

            for (let i = 0; i < codigosEspecies.length; i++)
            {
                especies.push(codigosEspecies[i]);
            }

            especies.push(especie);

            setCodigosEspecies(especies);
        }
        else
        {
            const especies = codigosEspecies.filter(nombre => nombre !== especie);

            setCodigosEspecies(especies);
        }

        // 1. Tu lógica para actualizar el estado en React
        setCheckboxesEspecies(
        {
            ...checkboxesEspecies,
            [especie]: checked
        });

        // 2. Enviar la acción a Google Tag Manager
        if (window.dataLayer)
        {
            window.dataLayer.push(
            {
                event: 'buscador_experto_pesqueria_checkbox_especie',
                buscador_experto_pesqueria_checkbox_especie: document.querySelector(`label[for="${e.target.id}"]`).textContent,
                checkbox_accion: checked ? 'marcado' : 'desmarcado',
            });
        }

        setPagination(1);
    }

    useEffect(() =>
    {
        let contador = 0;

        especies.map((especie) => (contador += especie.REGISTROS));

        setCount(contador);
    }, [especies]);

    const groupedEspecies = especies.reduce((acc, especie) =>
    {
        const firstLetter = especie.NOMBRE_ESPECIE[0].toUpperCase();

        if (!acc[firstLetter])
        {
            acc[firstLetter] = [];
        }

        acc[firstLetter].push(especie);

        return acc;
    }, {});

    return (
        count > 0 &&
        (
            <div className="card border-0 mb-1">
                <div className="accordion" id="accordionPanelEspecie">
                    <div className="accordion-item">
                        <h5 className="accordion-header"><button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsEspecies" aria-expanded="true" aria-controls="panelsEspecies">Especies:</button></h5>
                        <div id="panelsEspecies" className="accordion-collapse collapse">
                            <div className="accordion" id="accordionEspecies">

                                {
                                    Object.keys(groupedEspecies).sort().map((letter, index) =>
                                    (
                                        <div className="accordion-item" key={index}>
                                            <h2 className="accordion-header" id={`heading-${index}`}>
                                                <button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${index}`} aria-expanded="false" aria-controls={`collapse-${index}`}>
                                                    {letter}
                                                </button>
                                            </h2>
                                            <div id={`collapse-${index}`} className="accordion-collapse collapse" aria-labelledby={`heading-${index}`}>
                                                <div className="accordion-body">

                                                    {
                                                        groupedEspecies[letter].map((especie, subIndex) =>
                                                        (
                                                            <div className="row" key={subIndex}>
                                                                <div className="col">
                                                                    <div className="form-check">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input border-dark-subtle"
                                                                            id={`especie-${index}-${subIndex}`}
                                                                            name="nombre_especie"
                                                                            value={especie.COD_ESPECIE}
                                                                            onChange={handleChildCheckbox}
                                                                            checked={Object.hasOwn(checkboxesEspecies, `${especie.COD_ESPECIE}`) ? checkboxesEspecies[`${especie.COD_ESPECIE}`] : false}
                                                                            disabled={!status422 && (!loading || checking || sorting)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`especie-${index}-${subIndex}`}>{especie.NOMBRE_ESPECIE}

                                                                            {
                                                                                especie.NOMBRE_CIENTIFICO && especie.NOMBRE_CIENTIFICO !== 'Sin nombre cientifico' &&
                                                                                (
                                                                                    <>
                                                                                        {' ('}<i>{especie.NOMBRE_CIENTIFICO}</i>{')'}
                                                                                    </>
                                                                                )
                                                                            }

                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                {
                                                                    appDebug === 'true' &&
                                                                    (
                                                                        <div className="col-3 text-end">{especie.REGISTROS.toLocaleString('es-CL')}</div>
                                                                    )
                                                                }

                                                            </div>
                                                        ))
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>

                        {
                            appDebug === 'true' &&
                            (
                                <div className="text-end p-2">Elementos totales: {count.toLocaleString('es-CL')}</div>
                            )
                        }

                    </div>
                </div>
            </div>
        )
    );
}

export default Especies;
